const preFixPath = prefix => path => `${prefix}${path}`;

const LANDING = "/user";
const ONBOARDING = "/onboarding";
const DASHBOARD = "/dashboard";
const SETTINGS = "/setting";

export const getRegPath = preFixPath(LANDING);
export const getOnboardingPath = preFixPath(ONBOARDING);
export const getDashboardPath = preFixPath(DASHBOARD);
export const getSettingPath = preFixPath(SETTINGS);
